import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { ISearchFilter } from "@shared/interface";
import { IsampleList } from "@shared/list/sample.list";

@Injectable({
  providedIn: 'root',
})
export class HttpClientTypeService {
  private http = inject(HttpClient);
  private urlApi = environment.apiUrl + '/client-type';

  list = [];

  init() {
    this.findAll({order: 'tic_Desc', direction: 'ASC', limit: 1000}).subscribe((resp) => {
      this.list = resp.data;
    });
  }

  findAll(filter: ISearchFilter) {
    return this.http.post<any>(`${this.urlApi}/all`, { ...filter });
  }

  getListClientType() {
      const resp: IsampleList[] = [];
      Object.values(this.list).forEach((l: any) => {
        resp.push({ id: l.tic_Cod, name: l.tic_Desc });
      });
      return resp;
    }
}